import { useEffect, useState } from "react";

interface Star {
  id: number;
  x: number;
  size: number;
  opacity: number;
  delay: number;
  duration: number;
}

interface FloatingDecorationsProps {
  density?: 'low' | 'medium' | 'high';
  className?: string;
}

export function FloatingDecorations({ density = 'medium', className = '' }: FloatingDecorationsProps) {
  const [stars, setStars] = useState<Star[]>([]);

  useEffect(() => {
    const counts = {
      low: 40,
      medium: 80,
      high: 150
    };

    const count = counts[density];
    const columns = 20; // Vertical lanes for organized distribution
    const starsPerColumn = Math.ceil(count / columns);
    const newStars: Star[] = [];

    for (let col = 0; col < columns; col++) {
      for (let row = 0; row < starsPerColumn; row++) {
        if (newStars.length >= count) break;
        
        newStars.push({
          id: col * starsPerColumn + row,
          x: (col / columns) * 100 + Math.random() * 3, // Slight randomness within lane
          size: 1 + Math.random() * 2, // 1-3px
          opacity: 0.3 + Math.random() * 0.7,
          delay: Math.random() * 20,
          duration: 15 + Math.random() * 15 // 15-30s fall time
        });
      }
    }

    setStars(newStars);
  }, [density]);

  return (
    <div className={`hidden dark:block absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {/* Falling stars */}
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute rounded-full bg-white animate-star-fall"
          style={{
            left: `${star.x}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            opacity: star.opacity,
            animationDelay: `${star.delay}s`,
            animationDuration: `${star.duration}s`,
            boxShadow: `0 0 ${star.size * 2}px rgba(255, 255, 255, 0.5)`
          }}
        />
      ))}
      
      {/* Shooting stars - only for medium/high density */}
      {density !== 'low' && (
        <>
          <div 
            className="absolute w-1 h-1 bg-white rounded-full animate-shooting-star"
            style={{ top: '10%', left: '-5%', animationDelay: '0s' }}
          />
          <div 
            className="absolute w-1 h-1 bg-white rounded-full animate-shooting-star"
            style={{ top: '30%', left: '-5%', animationDelay: '5s' }}
          />
          <div 
            className="absolute w-1 h-1 bg-white rounded-full animate-shooting-star"
            style={{ top: '60%', left: '-5%', animationDelay: '12s' }}
          />
        </>
      )}
    </div>
  );
}
